import React, { useEffect, useState } from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Box, Button, Grid, IconButton, InputLabel, LinearProgress, MenuItem, OutlinedInput, Select, Tooltip } from '@mui/material';
import BaseAppService from '../../../../application/platform/scp/base/base-app-service';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { Pagination } from '../../../../model/pagination';
import { IFilePageRequest } from '../../../../model/scp/base/request/file-paged-request';
import { IFileResponse } from '../../../../model/scp/base/response/file-response';
import DefaultUploadFile from '../../../../components/default-upload-file';
import { ITableResponse } from '../../../../model/scp/purchase/response/tables-response';
import { IFileAddRequest } from '../../../../model/scp/base/request/file-add-request';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { DefaultDialogProps } from '../../../../components/default-dialog';
import { IContractAddEditRequest } from '../../../../model/scp/contract/request/contract-add-edit-request';
import ContractAppService from '../../../../application/platform/scp/contract/contract-app-service';
import { useBaseLayout } from '../../../../components/context/use-base-layout';
import { dataGridLocaleConfig } from '../../../../config/data-grid-locale';

export interface IContractFileDataTableProps {
    contractReqeust: IContractAddEditRequest,
    contractId?: string | undefined,
    setFiles: (files: IFileAddRequest[]) => void
};

export default function ContractFileDataTable({ props }: { props: IContractFileDataTableProps }) {
    const { showDialog, showMessage, showLoading } = useBaseLayout();
    const [filesContractRequest, setFilesContractRequest] = useState<IFileAddRequest[]>([]);
    const [fileContractRequest, setFileContractRequest] = useState<IFileAddRequest>({ id: props.contractId } as IFileAddRequest);
    const [fileContractResponse, setFileContractResponse] = useState<Pagination<IFileResponse>>({ items: [] } as unknown as Pagination<IFileResponse>);
    const [contractFilesRequest, setContractFilesRequest] = useState<IFilePageRequest>({ id: props.contractId, page: 1, pageSize: 100 } as IFilePageRequest);
    const [loadMoreData, setLoadMoreData] = useState(false);
    const [error, setError] = useState(false);
    const [typeDocument, setTypeDocument] = useState<ITableResponse[]>([]);

    useEffect(() => {
        (async () => {

            let documentTypes = await BaseAppService.listTypeDocument(4);
            setTypeDocument(documentTypes);
        })();
    }, []);

    useEffect(() => {
        (async () => {
            await loadData();
        })();
    }, [props.contractId]);

    const loadData = async () => {
        if (props.contractId !== undefined) {
            setLoadMoreData(true);
            let purchaseItems = await ContractAppService.listContractFiles(contractFilesRequest);
            setFileContractResponse(purchaseItems);
            setLoadMoreData(false);
        }
    }

    const handleOnChange = (e: any) => {
        let title = fileContractRequest?.title;
        let documentTypeId = fileContractRequest?.documentTypeId;
        let typeDocumentName = fileContractRequest?.typeDocumentName;
        if (e !== undefined) {
            if (e.target.name === "input-title-atachment") {
                title = e.target.value;
            } else if (e.target.name === "select-document-type-atachment") {
                documentTypeId = e.target.value;
                var typeDocumentResult = typeDocument?.find(x => Number(x.id) === Number(documentTypeId));
                if (typeDocumentResult !== undefined)
                    typeDocumentName = typeDocumentResult?.name;
            }

        }
        setFileContractRequest(prevState => {
            return { ...prevState, title, documentTypeId, typeDocumentName: typeDocumentName };
        });
    }

    const saveFile = () => {
        if (validFields()) {
            if (props.contractId !== undefined) {
                (async () => {
                    showLoading({ open: true });

                    await ContractAppService.addFileContract(fileContractRequest);

                    showMessage({ open: true, message: "Documento adicionado com sucesso!", type: "success" });
                    showLoading({ open: false });
                    setFileContractRequest({ id: props.contractId } as IFileAddRequest);
                    loadData();
                })();
            } else {
                fileContractRequest.sequence = filesContractRequest.length + 1;
                setFilesContractRequest([...filesContractRequest, fileContractRequest]);


                setFileContractResponse(prevState => {
                    return { ...prevState, items: [...filesContractRequest, fileContractRequest], totalRecords: prevState.totalRecords !== undefined ? prevState.totalRecords + 1 : 1, pageCount: 1 } as unknown as Pagination<IFileResponse>;
                });

                setFileContractRequest({ id: props.contractId } as IFileAddRequest);

                props.setFiles([...filesContractRequest, fileContractRequest]);
            }
        } else {
            showMessage({ open: true, message: "Preencha todos os campos obrigatórios!", type: "error" });
        }
    }

    const columns: GridColDef<IFileResponse>[] = [
        {
            field: 'number',
            headerName: 'Nº',
            flex: 1, sortable: false,
            disableColumnMenu: true,
            align: 'right',
            headerAlign: 'right'
        },

        {
            field: 'title',
            headerName: 'Titulo',
            flex: 5, sortable: false,
            disableColumnMenu: true
        },
        {
            field: 'documentTypeDescription',
            headerName: 'Tipo',
            flex: 2, sortable: false,
            disableColumnMenu: true,
        }
        ,
        {
            field: 'actions',
            type: 'actions',
            flex: 1,
            headerName: '',
            width: 100,
            renderCell: (params) => {

                return [
                    <Tooltip title="Excluir">
                        <IconButton aria-label="Excluir" onClick={() => {
                            if (props.contractId !== undefined) {
                                showDialog({
                                    title: 'Pergunta', message: 'Deseja realmente excluir o documento? Caso deseje excluir preencha a justificativa abaixo:', onYesClick: (justification: string) => {
                                        if (justification !== undefined && justification.length > 0) {
                                            (async () => {
                                                if (props.contractId !== undefined && params.row.number !== undefined) {
                                                    showLoading({ open: true });
                                                    await ContractAppService.deleteFileContract(justification, Number(props.contractId), params.row.number);
                                                    loadData();
                                                    showLoading({ open: false });
                                                    showMessage({ message: 'Anexo excluída com sucesso', type: 'success', open: true });
                                                }
                                            })();
                                        } else {
                                            showMessage({ message: 'Informe a justificativa para excluir o anexo', type: 'warning', open: true });
                                        }
                                    }, inputProps: {
                                        rows: 4
                                    }
                                } as DefaultDialogProps);
                            } else {
                                showDialog({
                                    title: 'Pergunta', message: 'Deseja realmente excluir o documento?', onYesClick: () => {
                                        var result = filesContractRequest.filter(x => x.sequence !== params.row.number);
                                        setFilesContractRequest(result);

                                        setFileContractResponse(prevState => {
                                            return { ...prevState, items: result, totalRecords: result.length, pageCount: 1 } as unknown as Pagination<IFileResponse>;
                                        });

                                        props.setFiles(result);
                                    }
                                } as DefaultDialogProps);
                            }
                        }}>
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip >
                ];
            }
        }
    ];

    const validFields = (): boolean => {
        let isValid = true;

        if (fileContractRequest.documentTypeId === undefined) {
            isValid = false;
        }
        if (fileContractRequest.document !== undefined && fileContractRequest.document === null) {
            isValid = false;
        }
        if (fileContractRequest.title !== undefined && fileContractRequest.title.length === 0) {
            isValid = false;
        }
        setError(!isValid);
        return isValid;
    }


    return (
        <React.Fragment>
            <Box sx={{ textAlign: 'right' }}>
                <Grid container spacing={2}
                    sx={{ mt: '10px', mb: '10px', pr: '10px', textAlign: 'left' }} >
                    <Grid item lg={2}
                        sm={2}
                        xl={2}
                    >
                        <InputLabel>Tipo de Arquivo</InputLabel>
                        <Select
                            autoComplete='off'
                            onChange={handleOnChange}
                            onBlur={handleOnChange}
                            fullWidth
                            error={fileContractRequest.documentTypeId === undefined && error ? true : false}
                            value={fileContractRequest.documentTypeId ? fileContractRequest.documentTypeId : ''}
                            name='select-document-type-atachment'
                        >
                            <MenuItem value={undefined}>
                                <em>Selecionar</em>
                            </MenuItem>
                            {typeDocument.map((element, index) => {
                                return (
                                    <MenuItem value={element.id} key={element.id}>{element.name}</MenuItem>
                                );
                            })}
                        </Select>
                    </Grid>
                    <Grid
                        item
                        lg={4}
                        sm={4}
                        xl={4}
                    >
                        <InputLabel>Titulo do Documento</InputLabel>
                        <OutlinedInput
                            autoComplete='off'
                            name="input-title-atachment"
                            error={(fileContractRequest.title === undefined || fileContractRequest.title.length === 0) && error ? true : false}
                            value={fileContractRequest.title ? fileContractRequest.title : ''}
                            fullWidth
                            onChange={handleOnChange}
                            onBlur={handleOnChange}
                        />
                    </Grid>
                    <Grid item lg={4}
                        sm={4}
                        xl={4}
                    >
                        <InputLabel>Tipo de Documento (pdf). Tamanho Max: 30mb </InputLabel>
                        <DefaultUploadFile props={{
                            id: "file-upload-document",
                            setFileUpload: (file: File) => {
                                setFileContractRequest(prevState => {
                                    return { ...prevState, document: file } as IFileAddRequest;
                                });
                            }, file: fileContractRequest.document, extensions: ["pdf"], maxFileSizeMb: 30, error: (fileContractRequest.document === undefined || fileContractRequest.document === null) && error ? true : false
                        }}></DefaultUploadFile>
                    </Grid>

                    <Grid lg={2}
                        sm={2}
                        xl={2}
                        item
                    >
                        <InputLabel> &nbsp; </InputLabel>
                        <Button variant="contained" fullWidth component="label" size="large" sx={{ height: '55px' }} startIcon={<PlaylistAddIcon />}
                            onClick={() => {
                                saveFile();
                            }}
                        >
                            Adicionar
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <DataGrid
                columns={columns}
                disableSelectionOnClick
                onPageChange={(newPage) => {
                    setContractFilesRequest({ ...contractFilesRequest, page: newPage });
                }}
                paginationMode="server"
                components={{
                    LoadingOverlay: LinearProgress,
                }}
                loading={loadMoreData}
                rowsPerPageOptions={[fileContractResponse?.pageSize]}
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                    columns: {
                        columnVisibilityModel: {
                            id: false,
                        },
                    },

                }}
                rowCount={fileContractResponse?.totalRecords}
                rows={fileContractResponse?.items}
                pagination={undefined}
                getRowId={(row: any) => row.number ?? row.sequence}
                localeText={dataGridLocaleConfig}
            />
        </React.Fragment>
    )
}